type UserNameLike =
  | {
      fullName?: string | null;
      surname?: string | null;
      name?: string | null;
    }
  | null
  | undefined;

export function getUserFullName(user: UserNameLike, fallback = ''): string {
  if (!user) {
    return fallback;
  }

  if (typeof user.fullName === 'string' && user.fullName.trim()) {
    return user.fullName.trim();
  }

  const canonicalName = [user.surname, user.name]
    .filter(Boolean)
    .join(' ')
    .trim();

  return canonicalName || fallback;
}
